import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { http } from 'utils'

Vue.use(VueI18n)

async function loadLocaleMessages () {
  const response = await http.get('translations')
  let messages = {}
  messages.en = { ...response.data, ...messages.en }
  i18n.setLocaleMessage('en', messages.en)
  return messages
}

const fallbackLocale = ['en']

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale,
  messages: {}
})
export default i18n

loadLocaleMessages()
